import React from 'react';

export const Loader = ({ title }: { title?: string }) => {
  return (
    <div className='text-center'>
      <h6>{title}</h6>
      <div className='spinner-grow text-primary' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
      <div className='spinner-grow text-danger' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
      <div className='spinner-grow text-success' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
    </div>
  );
};

export const LoaderSmall = () => {
  return (
    <div className='text-center'>
      <div className='spinner-grow spinner-grow-sm text-primary' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
      <div className='spinner-grow spinner-grow-sm text-danger' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
      <div className='spinner-grow spinner-grow-sm text-success' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
    </div>
  );
};

export const NoRows = () => {
  return <span>no records to view </span>;
};
